import React from "react";
import i18n from 'i18n-js';

import "../css/ExcellFilter.css";

export default class ExcellFilter extends React.Component {
    state = {
        search: "",
        sort: false,
        selected: [],
    };

    filter()
    {
        let data = (this.props.data || []);
        if(this.state.search.length > 0)
        {
            data = data.filter(d => d.name.toLowerCase().includes(this.state.search));
        }
        return data;
    }

    updateFilter()
    {
        //updateData
        let data = this.props.allData;

        // Filter
        if(this.state.selected.length > 0)
        {
            data = data.filter(d => {
                const check = this.state.selected.some(sel => {
                    if(sel.key === "extraFieldText")
                    {
                        return d.extras.some(d => d.textAnswer === sel.value || d.answer === sel.value);
                    }
                    return d[sel.key] === sel.value;
                });
                return check;
            });
        }

        // Sort
        if(this.state.sort)
        {
            data = data.sort((a, b) => {
                const aCheck = this.state.sort === "asc" ? a[this.props.dataKey] > b[this.props.dataKey] : a[this.props.dataKey] < b[this.props.dataKey];

                if(a === b)
                {
                    return 0;
                }else if(aCheck)
                {
                    return 1;
                }else{
                    return -1;
                }
            });
        }

        this.props.updateData(data);
    }

    setSort(type)
    {
        if(type !== this.state.sort)
        {
            this.setState({
                sort: type,
            });
            requestAnimationFrame(() => this.updateFilter());
        }
    }

    updateValues(options)
    {
        const data = this.filter();
        const selected = [...options].map(d => data[Number(d.value)]);
        this.setState({
            selected
        });
        requestAnimationFrame(() => this.updateFilter());
    }

    render()
    {
        if(!this.props.visible)
        {
            return null;
        }

        const data = this.filter();
        return (<div className="filterMenu" style={{left: this.props.x || 0}}>
        <div className="filerMenuPoint" onClick={() => this.setSort("asc")}>
            <i className="fa fa-sort-alpha-asc" aria-hidden="true"></i> {i18n.t("SORT_ASC")}
        </div>
        <div className="filerMenuPoint" onClick={() => this.setSort("desc")}>
            <i className="fa fa-sort-alpha-desc" aria-hidden="true"></i> {i18n.t("SORT_DESC")}
        </div>
        <div className="filerMenuPoint">
          <input placeholder={i18n.t("SEARCH")} onChange={e => this.setState({search: e.target.value.toLowerCase()})}/>
        </div>
        <select multiple={true} onChange={e => this.updateValues(e.target.selectedOptions)} key={data.length}>
          {
              data.map((val, i) => <option value={i} key={i}>{val.name}</option>)
          }
        </select>
    </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/UI/ExcellFilter.js